var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"modal",on:{"click":_vm.closeModalOnTarget}},[_c('button',{staticClass:"close-button",on:{"click":_vm.closeModal}},[_c('Cross',{attrs:{"color":"#FFFFFF","width":17}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }